import router from '../routes';
import * as Sentry from '@sentry/vue';

export default (Vue) => {
    Sentry.init({
        Vue: Vue,
        dsn: window.grinEnv.SENTRY_DSN,
        environment: window.grinEnv.SENTRY_ENVIRONMENT,
        integrations: [
            // Or omit `router` if you're not using vue-router
            Sentry.browserTracingIntegration({ router }),
            Sentry.vueIntegration({}),
            Sentry.replayIntegration({
                blockAllMedia: true
            })
        ],
        initialScope: {
            account_id: window.SERVER_DATA?.account?.id,
            contact_id: window.SERVER_DATA?.contact?.id,
            creator_id: window.SERVER_DATA?.creator_id,
            account_creator_id: window.SERVER_DATA?.account_creator_id,
        },
        tracesSampleRate: window.grinEnv.SENTRY_TRACES_SAMPLE_RATE,
        replaysSessionSampleRate: window.grinEnv.SENTRY_REPLAYS_SAMPLE_RATE
    });
};
